export default $api => {
  $api.register('insurance-api', '/web/private/client', request => ({
    getInsuranceDebtItems(withInsurance = true) {
      return request('GET', '/debt-items', {
        params: {
          withFastFee: 0,
          withInsurance: Number(withInsurance),
        },
      });
    },
    acceptWithInsurance(payload) {
      return request('POST', '/active-application-insurance/accept', payload);
    },
    acceptWithoutInsurance(payload) {
      return request('POST', '/active-application-without-insurance/accept', payload);
    },
  }));
};
